export enum ExtraParamsField
{

    TOKEN       = "token",
    LEVEL       = "level",
    LEVELID     = "levelid",
    UUID        = "uuid",
    CODE        = "code",
    TYPE        = "type",
    CODES       = "codes",
}